export const FETCH_CATEGORIES_BOARD = 'FETCH_CATEGORIES_BOARD'
export const FETCH_CATEGORIES_BOARD_SUCCESS = 'FETCH_CATEGORIES_BOARD_SUCCESS'
export const FETCH_CATEGORIES_BOARD_FAILURE = 'FETCH_CATEGORIES_BOARD_FAILURE'

export const fetchCategoriesBoard = () => ({
    type: FETCH_CATEGORIES_BOARD
})

export const fetchCategoriesBoardSuccess = (categories) => ({
    type: FETCH_CATEGORIES_BOARD_SUCCESS,
    payload: categories
})

export const fetchCategoriesBoardFailed = (message) => ({
    type: FETCH_CATEGORIES_BOARD_FAILURE,
    payload: message
})